var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77821 0.777771L7.33377 7.88888H12.6671L9.11155 0.777771H12.6671L16.2227 7.88888H21.556L18.0004 0.777771H21.556L25.1115 7.88888H30.4449L26.8893 0.777771H32.2227C33.2004 0.777771 34.0378 1.12622 34.7347 1.8231C35.4304 2.51881 35.7782 3.35555 35.7782 4.33333V25.6667C35.7782 26.6444 35.4304 27.4818 34.7347 28.1787C34.0378 28.8744 33.2004 29.2222 32.2227 29.2222H3.77821C2.80043 29.2222 1.96369 28.8744 1.26799 28.1787C0.571101 27.4818 0.222656 26.6444 0.222656 25.6667V4.33333C0.222656 3.35555 0.571101 2.51881 1.26799 1.8231C1.96369 1.12622 2.80043 0.777771 3.77821 0.777771ZM3.77821 11.4444V25.6667H32.2227V11.4444H3.77821Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.0a35aa19e4efad0298c55715d4c07e65.svg";
export { ForwardRef as ReactComponent };